export default {
      id: "circle__speed_lg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__speed_lg",
      toString: function () {
        return this.url;
      }
    }